import {useNavigate} from 'react-router-dom';
import {Button} from 'alm-react-components';

import CarouselSection from '../../common/CarouselSection';
import useGetEnrolled from '../../../hooks/useGetEnrolled';
import {APPROUTES, constants} from '../../../assets/constants/constants';
import {useContext, useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import { compareByWeek, LibraryFilteration } from '../../../lib/utils';
import { AppContext } from '../../../context/AppProvider';
type VideoSectionType = {
  videos: any;
  addBookMark: any;
  deleteBookMark: any;
  catalogId: any;
};
const VideoSection = ({videos, addBookMark, deleteBookMark, catalogId}: VideoSectionType) => {
  const navigate = useNavigate();
  const {tagsData} = useGetEnrolled();
  const {t} = useTranslation();
  const [filteredVideos, setFilteredVideos] = useState<any[]>([]);
  const { state } = useContext(AppContext);
  useEffect(() => {
    const data = LibraryFilteration(tagsData, videos, constants.NEW_VIDEO)
    const sortedData=data?.sort(compareByWeek)
    setFilteredVideos(sortedData);
  }, [tagsData, videos])

  if (!filteredVideos || filteredVideos.length === 0) {
    return null;
  }

  return (
    <div className="mt-14 mb-14 xl:px-32 lg:px-8 md:px-8 px-5">
      <div className="flex flex-wrap justify-between md:flex-nowrap">
        <h2 className="text-3xl font-barlowLight pl-2 max-md:mb-4">
        <span dangerouslySetInnerHTML={{ __html: t('Library.videos') }} /></h2>
        {!state?.keyword&&( 
          <Button
            variant="outline"
            onClick={() => navigate(`/videos/${catalogId?.id}`)}
            className="text-base font-normal px-6 py-1 h-9 dark:bg-fillMidGrayCard border-0"
          >
            <span dangerouslySetInnerHTML={{ __html: t('Common.seeAll') }} />
          </Button>)}
      </div>
      <CarouselSection
        data={filteredVideos}
        addBookMark={addBookMark}
        deleteBookMark={deleteBookMark}
        type={'Videos'}
        id={catalogId?.id}
        from={APPROUTES.library}
      />
    </div>
  );
};

export default VideoSection;
